import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      overflow: auto;\n      padding: 5px 0;\n      outline: none;\n      background: ", ";\n    "])), t.bgDefault);
  },
  shadow: function shadow(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      border: ", ";\n      box-shadow: ", ";\n    "])), t.menuBorder, t.menuShadow);
  },
  header: function header() {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      top: -5px;\n      position: relative;\n      z-index: 1;\n      width: 100%;\n      overflow: hidden;\n      line-height: 18px;\n      box-sizing: border-box;\n      padding: 6px 18px 7px 8px;\n    "])));
  },
  footer: function footer() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      bottom: -5px;\n      position: relative;\n      z-index: 1;\n      width: 100%;\n      overflow: hidden;\n      line-height: 18px;\n      box-sizing: border-box;\n      padding: 6px 18px 7px 8px;\n    "])));
  },
  fixedHeader: function fixedHeader() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);\n    "])));
  },
  fixedFooter: function fixedFooter() {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.1);\n    "])));
  }
});